import React, { useState } from 'react';

import { Error } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Button, TableCell, TableRow } from '@mui/material';

import { patchCandidate, patchCandidateReviewStatus } from 'api';
import { AlertModal, Link } from 'components';
import {
  getLabel,
  reviewStatusOptions,
  getFullUserNameOrId,
  convertUTCDateTimeToDateTime,
  countryOptions,
} from 'helpers';
import { useSnackContext } from 'hooks/useSnackContext';
import {
  CandidateSummaryRowProps,
  ReviewedFullCandidateProps,
  TrancheStatus,
} from 'types';
export const ReviewedCandidateSummaryRow = (props: {
  summary: CandidateSummaryRowProps;
  trancheStatus?: TrancheStatus;
  setCandidate: React.Dispatch<
    React.SetStateAction<ReviewedFullCandidateProps>
  >;
}) => {
  const { summary, trancheStatus, setCandidate } = props;
  const {
    reviewStatusId,
    comment,
    workDays,
    organization,
    derog,
    reportedBy,
    reportedDate,
    candidateId,
    status,
  } = summary;
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const { setSnack } = useSnackContext();

  const sendBack = async () => {
    //if tranche sta
    if (trancheStatus && trancheStatus !== 'active') {
      return;
    }

    setLoading(true);
    try {
      await patchCandidateReviewStatus(candidateId, {
        data: {
          review_status: 'review_in_progress',
          organization_id: organization.id,
        },
      });
      if (trancheStatus === 'active') {
        const { data } = await patchCandidate(candidateId, {
          data: {
            tranche_id: 0,
          },
        });
        setSnack((props) => ({
          ...props,
          severity: 'success',
          open: true,
          message:
            'Removed Candidate From Tranche And Sent Back For Further Review',
        }));
        setCandidate((prev) => ({ ...prev, ...data }));
      } else {
        setSnack((props) => ({
          ...props,
          severity: 'success',
          open: true,
          message: 'Sent Back For Further Review',
        }));
        setCandidate((prev) => ({
          ...prev,
          review_status: 'review_in_progress',
        }));
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
      setSnack((props) => ({
        ...props,
        severity: 'error',
        open: true,
        message: 'Error Sending Candidate For Further Review',
      }));
    }

    setLoading(false);
  };
  return (
    <>
      <TableRow
        key={reviewStatusId}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell
          key={`${reviewStatusId}-employer`}
          component='th'
          scope='row'
        >
          <Link
            to={`/home/candidate_admin_dashboard/organizations/${organization.id}`}
            variant='body2'
          >
            {organization.name}
          </Link>
        </TableCell>
        <TableCell
          key={`${reviewStatusId}-employer-location`}
          component='th'
          scope='row'
        >
          {organization.country
            ? getLabel({ value: organization.country, options: countryOptions })
            : 'Unknown'}
        </TableCell>
        <TableCell key={`${reviewStatusId}-options`} align='left'>
          {getLabel({ value: status, options: reviewStatusOptions })}
        </TableCell>
        <TableCell key={`${reviewStatusId}-comment`} align='left'>
          {comment || ''}
        </TableCell>
        <TableCell key={`${reviewStatusId}-days`} align='left'>
          {workDays}
        </TableCell>
        <TableCell key={`${reviewStatusId}-derog`} align='left'>
          {derog ? <Error color='error' fontSize='small' /> : '--'}
        </TableCell>
        <TableCell key={`${reviewStatusId}-reported-by`} align='left'>
          {reportedBy ? (
            <Link
              to={`/home/candidate_admin_dashboard/users/${reportedBy.id}`}
              variant='body2'
            >
              {getFullUserNameOrId(reportedBy)}{' '}
            </Link>
          ) : (
            '--'
          )}
        </TableCell>
        <TableCell key={`${reviewStatusId}-reported-date`} align='left'>
          {reportedDate ? convertUTCDateTimeToDateTime(reportedDate) : '--'}
        </TableCell>
        <TableCell key={`${reviewStatusId}-action`} align='left'>
          <Button
            disabled={['pending_user_review', 'review_in_progress'].includes(
              status,
            )}
            onClick={() => setAlert(true)}
            size='small'
            variant='text'
          >
            Send back
          </Button>
        </TableCell>
      </TableRow>
      <AlertModal
        open={alert}
        heading='Sending this candidate back to an employer for edits will remove them from a tranche.'
        subHeading='Their information will not be sent to the State Department'
      >
        <LoadingButton loading={loading} onClick={sendBack}>
          Send Back
        </LoadingButton>
        <Button onClick={() => setAlert(false)}>Cancel</Button>
      </AlertModal>
    </>
  );
};
